"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.clyde.description': 'British man with power, nuance and humor.',
};
